import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteParceiro() {
  return useMutation(
    `/v1/parceiro/id`,
    (id: string) => http.delete(`/v1/parceiro/${id}`),
    { retry: false }
  );
}

export default useDeleteParceiro;
